var map = {
	"./audio.png": "f167",
	"./doc.png": "493f",
	"./docx.png": "573b",
	"./file.png": "cd24",
	"./image.png": "cc93",
	"./pdf.png": "f35f",
	"./txt.png": "d36d",
	"./xls.png": "d75a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7644";